import { useState } from "react";
import { Activity, ShieldCheck, FlaskConical, Undo2 } from "lucide-react";
import DJMixer from "./DJMixer";
import ExperimentPipeline from "./ExperimentPipeline";

const HCard = ({ tone, icon: Icon, label, value }) => (
  <div className={"lab-hcard " + tone}>
    <span className="l">{label}</span>
    <span className="v"><Icon size={15} />{value}</span>
  </div>
);

// CONTROL LAB — laboratoire de pilotage VORTEX. Bandeau santé + Control Surface + Pipeline.
// Le Founder formule une hypothèse → TULUSS/VORTEX la testent → preuve → décision. Lecture + replay.
export default function ControlLab({ selectedExpId, onSelectExp }) {
  const [gov, setGov] = useState(null);
  const [refresh, setRefresh] = useState(0);
  const g = gov?.governance;

  const onProposed = (exp) => { onSelectExp(exp.experiment_id); setRefresh((n) => n + 1); };

  return (
    <div className="lab" data-testid="control-lab">
      <div className="lab-health" data-testid="lab-health">
        <HCard tone={g?.freeze ? "warn" : "ok"} icon={ShieldCheck} label="Champion Health"
          value={g ? (g.freeze ? "GEL ACTIF" : `config v${g.current_version}`) : "…"} />
        <HCard tone="shadow" icon={Activity} label="Shadow Status"
          value={gov ? gov.historical_replay.includes("INSUFFICIENT") ? "SHADOW réel" : "replay" : "…"} />
        <HCard tone="shadow" icon={FlaskConical} label="Active Experiments"
          value={gov?.active_experiments ?? "…"} />
        <HCard tone={g?.kill_switch ? "crit" : (g?.rollback_ready ? "ok" : "warn")} icon={Undo2}
          label="Rollback Ready"
          value={g ? (g.kill_switch ? "KILL SWITCH" : (g.rollback_ready ? `STABLE v${g.stable_version}` : "aucune STABLE")) : "…"} />
      </div>
      <div className="lab-body">
        <div className="lab-col mixer">
          <DJMixer onProposed={onProposed} onGovernance={setGov} />
        </div>
        <div className="lab-col">
          <ExperimentPipeline selectedExpId={selectedExpId} onSelectExp={onSelectExp} refreshSignal={refresh} />
        </div>
      </div>
    </div>
  );
}
